import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "login" */ './index'),
  loading: () => null,
})
